module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-container', {
    staticClass: "dod-contract-analytics-view",
    staticStyle: {
      "padding-top": "60px",
      "max-width": "1442px"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "mt-4": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "page-header-body",
    attrs: {
      "xs12": "",
      "sm12": "",
      "md9": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('p', {
    staticClass: "page-header",
    staticStyle: {
      "color": "#4a4a4a",
      "font-size": "29px",
      "font-weight": "bolder",
      "text-justify": "auto"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.page.header))])]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "color": "#4a4a4a",
      "font-size": "18px",
      "font-weight": "400",
      "margin": "0px"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "-10px",
      "padding-top": "0px"
    }
  }, [_c('p', {
    staticClass: "page-header-subtext page-subtitle",
    staticStyle: {
      "text-justify": "auto",
      "line-height": "22px"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.page.sub_text) + "\n          ")])])])], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "mt-2": ""
    }
  }, [_c('v-card', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.analysisList), function(analysis, index) {
    return (_vm.privileges.economic_impact && _vm.privileges.economic_impact[analysis.id]) ? _c('v-flex', {
      key: index,
      attrs: {
        "xs12": "",
        "md3": "",
        "xl3": "",
        "pa-2": ""
      }
    }, [_c('router-link', {
      staticClass: "contract-analysis-tile-link",
      attrs: {
        "to": ("dod-contract-analytics/" + (analysis.id)),
        "exact": ""
      }
    }, [_c('div', {
      staticClass: "contract-analysis-tile secondary",
      style: ({
        'backgroundImage': ("url('/static/img/gdx-dod-contract-analytics-tile-" + (index + 1) + ".png')")
      })
    }, [_c('span', {
      staticClass: "white--text"
    }, [_vm._v(_vm._s(analysis.text))])])])], 1) : _vm._e()
  }), 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-aefbaf16","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/DoDContractAnalyticsView.vue
// module id = 1718
// module chunks = 36